import * as React from "react";
import * as PropTypes from "prop-types";
import { $, merge } from "glamor";
import classNames from "classnames";
import { rawTheme } from "styles/theme";
import { decodeHtml } from "../../utils/utilities";
import { DATATEST } from "constants/integration";
import type { IScope } from "reducers/scope";
import { Pricing } from "./pricing";

interface IProps {
    product: any;
    productViewDef?: any;
    linkToFullpage?: boolean;
    scope: IScope;
}

export class Header extends React.PureComponent<IProps, any> {
    static contextTypes = {
        me: PropTypes.object,
    };
    private styles = merge(
        {
            display: "flex",
            padding: "0 0 16px",
            // margin: "0 0 16px",
            // borderBottom: `1px solid ${rawTheme.palette.lightGrey}`,
        },
        $(" .title", {
            color: rawTheme.palette.darkerGrey,
            margin: "0",
            lineHeight: "32px",
            fontWeight: "bold",
            fontSize: "24px",
            letterSpacing: "0.3px",
        }),
        $(" .title.small", {
            fontSize: "22px",
            letterSpacing: "0.2px",
        }),
        $(" .titleLink", {
            color: rawTheme.palette.darkerGrey,
            display: "block",
        }),
        $(" .field", {
            fontSize: "14px",
            lineHeight: "20px",
            letterSpacing: "0.2px",
            color: rawTheme.palette.darkerGrey,
        }),
        $(" .fields", {
            flexShrink: 1,
            flexGrow: 1,
        }),
    );

    render() {
        const { me } = this.context;
        const { product, productViewDef, linkToFullpage, scope } = this.props;

        if (!productViewDef) {
            return null;
        }

        const headerViewSection = productViewDef.sections.get("header");
        const canViewPricing = !!productViewDef.sections.get("pricing");

        let title = null;
        const fields = [];
        if (headerViewSection && headerViewSection.elements) {
            headerViewSection.elements.forEach((element, i) => {
                const value = decodeHtml(element.getValue(product));
                if (value) {
                    if (i === 0) {
                        title = (
                            <h2 key="title" className={classNames("title", { small: value.length > 18 })}>
                                {linkToFullpage && (
                                    <a className="titleLink" href={product.getLink(scope)}>
                                        {value}
                                    </a>
                                )}
                                {!linkToFullpage && value}
                            </h2>
                        );
                    } else {
                        fields.push(
                            <p key={i} className="field">
                                {value}
                            </p>,
                        );
                    }
                }
            });
        }

        return (
            <header data-test={DATATEST.GALLERY.ITEM_PREVIEW_HEADER} {...this.styles}>
                <div className="fields">
                    {title}
                    {fields}
                </div>
                {canViewPricing && <Pricing scope={scope} product={product} currency={me._activeCurrency} />}
            </header>
        );
    }
}
